jQuery(document).ready(function (){

    // Parking filters
    var $categories = jQuery('.single-parking');
    var $buttons = jQuery('.cat-item');
    var $first = jQuery($buttons.get(0));

    $categories.addClass('active');
    $first.addClass('active');

    $buttons.find("a").each(function() {
        var className = jQuery(this).parent().attr('class');
        var matches = /(cat-item-\d{1,})/.exec(className);
        var dataid = matches.length > 1 ? matches[1] : null;
        if(dataid == null) {
            return;
        }

        jQuery(this).removeAttr("href");
        jQuery(this).parent().prepend('<input type="checkbox">');

        jQuery(this).on('click', function() {
            $categories.removeClass('active');
            $buttons.removeClass('active');

            $categories.filter('[data-id*="' + dataid + '"]').addClass('active');
            $buttons.filter('.' + dataid).addClass('active');
        });
    });

});